import { jsxs as s, jsx as x } from "react/jsx-runtime";
import { c as y } from "react/compiler-runtime";
import t from "moment-timezone";
const b = {
  label: {
    fontSize: "10px",
    color: "#5A5A5A",
    display: "flex"
  },
  input: {
    padding: "4px 8px",
    fontSize: "14px",
    cursor: "pointer",
    minWidth: "200px",
    borderRadius: "8px",
    border: "1px solid #EFEFEF",
    backgroundColor: "#F7F7F7",
    color: "#5A5A5A",
    fontWeight: 500,
    lineHeight: "14px",
    height: "32px"
  }
};
function h(l) {
  const e = y(23), n = l.type ?? "datetime-local", a = n === "date" ? "YYYY-MM-DD" : n === "time" ? "HH:mm" : "YYYY-MM-DDTHH:mm", u = l.label ?? "Time";
  let i;
  e[0] !== u ? (i = /* @__PURE__ */ x("label", { children: /* @__PURE__ */ x("span", { style: b.label, children: u }) }), e[0] = u, e[1] = i) : i = e[1];
  let o;
  e[2] !== a || e[3] !== l.value ? (o = t(l.value).format(a), e[2] = a, e[3] = l.value, e[4] = o) : o = e[4];
  let m;
  e[5] !== a || e[6] !== l.max ? (m = l.max ? t(l.max).format(a) : void 0, e[5] = a, e[6] = l.max, e[7] = m) : m = e[7];
  let f;
  e[8] !== a || e[9] !== l.min ? (f = l.min ? t(l.min).format(a) : void 0, e[8] = a, e[9] = l.min, e[10] = f) : f = e[10];
  let d;
  e[11] !== l ? (d = (g) => {
    const v = t(g.target.value).toDate();
    l.onChange(v);
  }, e[11] = l, e[12] = d) : d = e[12];
  let r;
  e[13] !== l.disabled || e[14] !== o || e[15] !== m || e[16] !== f || e[17] !== d || e[18] !== n ? (r = /* @__PURE__ */ x("input", { type: n, style: b.input, value: o, max: m, min: f, disabled: l.disabled, onChange: d }), e[13] = l.disabled, e[14] = o, e[15] = m, e[16] = f, e[17] = d, e[18] = n, e[19] = r) : r = e[19];
  let c;
  return e[20] !== i || e[21] !== r ? (c = /* @__PURE__ */ s("div", { children: [
    i,
    r
  ] }), e[20] = i, e[21] = r, e[22] = c) : c = e[22], c;
}
function F({
  startTime: l,
  endTime: e,
  onChange: n,
  min: a,
  max: u = t().toDate()
}) {
  return /* @__PURE__ */ s("div", { style: {
    display: "flex"
  }, children: [
    /* @__PURE__ */ x(h, { label: "From", value: l, min: a, max: e, disabled: t(l).isSameOrAfter(t(e)), onChange: (i) => {
      t(i).isSameOrAfter(t(e)) || n(i, e);
    } }),
    /* @__PURE__ */ x(h, { label: "To", value: e, min: l, max: u, disabled: t(e).isSameOrBefore(t(l)), onChange: (i) => {
      t(i).isSameOrBefore(t(l)) || n(l, i);
    } })
  ] });
}
export {
  F as DateTimePicker,
  h as TimeDateInput,
  h as default
};
